import { createSelector } from 'reselect';
import { get } from 'lodash';

export const selectParentSubstate = (state) => ({ ...get(state, 'parentTrack') });

export const selectParentTrack = createSelector(
  [selectParentSubstate],
  (substate) => (get(substate, 'data'))
);
